import { render, staticRenderFns } from "./acquisitionMonitoring.vue?vue&type=template&id=2956478c&scoped=true"
import script from "./acquisitionMonitoring.vue?vue&type=script&lang=js"
export * from "./acquisitionMonitoring.vue?vue&type=script&lang=js"
import style0 from "./acquisitionMonitoring.vue?vue&type=style&index=0&id=2956478c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2956478c",
  null
  
)

export default component.exports